import { useEffect, useState } from 'react';
import FieldError from '../../common/FieldError';
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { useMutation } from "@tanstack/react-query";
import { toast } from 'react-toastify';

export const ChangeUserPassword = ({ active = false}) => {
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        setPassword('');
        setNewPassword('');
        setNewPasswordConfirm('');
    }, []);

    const passwordChangeMutate = useMutation({
        mutationFn:(data)=>Api.post('/api/user/change/password', data),
        onSuccess:()=>{
            toast.success('비밀번호를 변경 했습니다.');
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err, '비밀번호 변경에 실패했습니다.');
            if(errorData.errors.length>0){
                setErrors(errorData.errors);
            }else{
                toast.error(errorData.message);
            }
        }
    });

    function onStore() {
        if( passwordChangeMutate.isPending ) return ;
        const storeData = { id: null, password, newPassword, newPasswordConfirm };
        passwordChangeMutate.mutate(storeData);
    }

    if (!active) return null;
    return (
        <>
            <div className="join show">
                <div className="join_input_area tab_body">
                    <div className="row mgT0">
                        <h4>기존 비밀번호</h4>
                        <FieldError name="password" errors={errors} >
                            <input type="password" name="password" value={password} maxLength="20" onChange={(e) => setPassword(e.target.value)} required={true} />
                        </FieldError>
                    </div>
                    <div className="row">
                        <h4>새 비밀번호</h4>
                        <FieldError name="newPassword" errors={errors} >
                            <input type="password" name="newPassword" value={newPassword} maxLength="20" onChange={(e) => setNewPassword(e.target.value)} required={true} />
                        </FieldError>
                    </div>
                    <div className="row">
                        <h4>새 비밀번호 확인</h4>
                        <FieldError name="newPasswordConfirm" errors={errors} >
                            <input type="password" name="newPasswordConfirm" value={newPasswordConfirm} maxLength="20" onChange={(e) => setNewPasswordConfirm(e.target.value)} required={true} />
                        </FieldError>
                    </div>
                </div>
            </div>
            <div className="btn_area">
                <button type="button" className="btn _blue" onClick={onStore}>저장</button>
            </div>
        </>


    )
}